import React from 'react';
import { Link } from 'react-router-dom';

export default function MarketplaceComingSoon() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-white to-blue-50 px-4">
      <div className="max-w-2xl w-full rounded-3xl border border-slate-200 bg-white shadow-xl p-8 md:p-12 text-center">
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-blue-600 mb-4">Marketplace</p>
        <h1 className="text-3xl md:text-5xl font-black text-slate-900 mb-4">Coming Soon</h1>
        <p className="text-slate-600 text-base md:text-lg leading-relaxed mb-8">
          The tutor marketplace is being prepared. Vetted tutors will be able to view requests and institutions will be able to post service needs here.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/dashboard"
            className="inline-flex items-center justify-center rounded-2xl bg-blue-600 px-6 py-3 text-white font-semibold hover:bg-blue-700 transition-colors"
          >
            Back to Dashboard
          </Link>
          <Link
            to="/tutor/vetting"
            className="inline-flex items-center justify-center rounded-2xl border border-slate-300 px-6 py-3 text-slate-700 font-semibold hover:bg-slate-50 transition-colors"
          >
            Check Vetting Status
          </Link>
        </div>
      </div>
    </div>
  );
}